import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import utils from "../../utils/utils";
import { LazyLoadImage } from "react-lazy-load-image-component";

class PipelineSquare extends React.Component {
  constructor(props) {
    super(props);
    this.interval = null;
    this.scrollInterval = null;
    this.canInterval = true;
    this.observer = null;
    this.wrapperRef = React.createRef();
    this.scrollContainerRef = React.createRef();
    this.listContainerRef = React.createRef();
  }

  componentDidMount() {
    // this.initVisibilityObserver();
    // this.timerID = setTimeout(() => {
    //   console.log('3333')
    //   this.handleScrollIntel();
    // }, 100);
  }
  
  componentWillUnmount() {
    clearTimeout(this.timerID);
    clearInterval(this.interval)
    clearInterval(this.scrollInterval)
    cancelAnimationFrame(this.animationFrame);
    if (this.observer) this.observer.disconnect();
  }

  // 法一：通过DOM移动卡片实现无限循环滚动（该方法因为频繁操作DOM会出现卡顿现象被优化为法二）
  // handleScrollIntel = () => {
  //   const scrollContainer = document.querySelector('.branchVenue');
  //   const listContainer = document.querySelector('.branchVenue-list');
  //   const squareList = this.props.config.list;

  //   if (squareList.length > 5 && scrollContainer) {
  //     cancelAnimationFrame(this.animationFrame);
      
  //     const direction = 'left';                     // 默认向左滚动
  //     const itemWidth = document.querySelector('.branchVenue-item').clientWidth + 7;
      
  //     let scrollSpeed = Math.max(1, itemWidth / 60) // 滚动速度 每帧滚动1px 每秒滚动60px
  //     let targetX = 0;                              // 目标滚动位置
      
  //     const scrollStep = () => {
  //       if (!this.canInterval) return;
        
  //       const curX = scrollContainer.scrollLeft;
  //       // 第一个魔方结束移到最后 实现循环
  //       if (curX >= itemWidth && listContainer && listContainer.firstElementChild) {
  //         const firstItem = listContainer.firstElementChild;
  //         listContainer.appendChild(firstItem);
  //         scrollContainer.scrollLeft = curX - itemWidth;
  //         targetX = curX - itemWidth;              // 更新targetX下一个魔方的起始位置
  //         return requestAnimationFrame(scrollStep);
  //       }
        
  //       targetX = curX + itemWidth;
  //       // 执行滚动动画
  //       const newX = direction === 'left' ? 
  //         Math.min(curX + scrollSpeed, targetX) : 
  //         Math.max(curX - scrollSpeed, targetX);
        
  //       scrollContainer.scrollTo({ left: newX });
  //       this.animationFrame = requestAnimationFrame(scrollStep);
  //     };
      
  //     this.animationFrame = requestAnimationFrame(scrollStep);
  //   }
  // };
  
    // checkManualScrollBoundaries = () => {
  //   const scrollContainer = document.querySelector('.branchVenue');
  //   const listContainer = document.querySelector('.branchVenue-list');
  //   if (!scrollContainer || !listContainer) return;

  //   const itemWidth = document.querySelector('.branchVenue-item').clientWidth + 7;
  //   const currentScroll = scrollContainer.scrollLeft;
  //   const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;

  //   // 情况1：向左滑动（从右往左），超过一个项目宽度 → 第一个项目移到末尾
  //   if (currentScroll >= itemWidth) {
  //     const firstItem = listContainer.firstElementChild;
  //     if (firstItem) {
  //       listContainer.appendChild(firstItem);
  //       scrollContainer.scrollLeft = currentScroll - itemWidth;
  //       console.log('向左滑动，第一个项目移到末尾');
  //     }
  //   }
  //   // 情况2：向右滑动（从左往右），滚动到最左端 → 最后一个项目移到开头
  //   else if (currentScroll <= 0) {
  //     const lastItem = listContainer.lastElementChild;
  //     if (lastItem) {
  //       listContainer.insertBefore(lastItem, listContainer.firstElementChild);
  //       scrollContainer.scrollLeft = currentScroll + itemWidth;
  //       console.log('向右滑动1，最后一个项目移到开头');
  //     }
  //   }
  //   // 情况3：向右滑动（从左往右），接近最右端 → 最后一个项目移到开头
  //   else if (currentScroll >= maxScroll - itemWidth) {
  //     const lastItem = listContainer.lastElementChild;
  //     if (lastItem) {
  //       listContainer.insertBefore(lastItem, listContainer.firstElementChild);
  //       scrollContainer.scrollLeft = currentScroll - itemWidth;
  //       console.log('向右滑动2，最后一个项目移到开头');
  //     }
  //   }
  // };


  // 法二：通过DOM复制列表实现无限循环滚动
  handleScrollIntel = () => {
    const scrollContainer = this.scrollContainerRef.current;
    const listContainer = this.listContainerRef.current;
    const squareList = this.props.config.list;

    if (!scrollContainer || !listContainer || squareList.length <= 5) return;

    cancelAnimationFrame(this.animationFrame);

    const direction = 'left';
    const itemWidth = listContainer.querySelector('.branchVenue-item').clientWidth + 7;
    const speedPerSecond = 73;

    // 注释原因：由于图像懒加载，使用克隆方法图片显示不出来，换成squareList直接复制一份
    // 克隆整组一次（仅执行一次）
    // if (!listContainer.dataset.cloned) {
    //   const cloneGroup = listContainer.cloneNode(true);
    //   cloneGroup.dataset.clone = 'true';
    //   listContainer.parentElement.appendChild(cloneGroup);
    //   listContainer.dataset.cloned = 'true';

    //   // 设置容器布局，保证两组横向并列
    //   listContainer.parentElement.style.display = 'flex';
    // }

    let lastTime = 0;
    const scrollStep = (now) => {
      if (!this.canInterval) return;

      const totalWidth = listContainer.scrollWidth / 2;
      let curX = scrollContainer.scrollLeft;

      if (!lastTime) lastTime = now;
      const dt = (now - lastTime) / 1000;
      lastTime = now;

      const delta = speedPerSecond * dt;

      if (direction === 'left') {
        curX += delta;
        if (curX >= totalWidth) {
          curX = 0;
        }
      } else {
        curX -= delta;
        if (curX <= 0) {
          curX = totalWidth;
        }
      }

      scrollContainer.scrollLeft = curX;
      this.animationFrame = requestAnimationFrame(scrollStep);
    };

    this.animationFrame = requestAnimationFrame(scrollStep);
  };

  handleItemClick = (item, index) => {
    if (!item.link) {
      // 空白不跳转
      return;
    }

    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }

    const options = {
      link: item.link,
      sort: index,
    };
    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams,convertUrl, item.link, options, -1, this.props, false);
  }

  initVisibilityObserver = () => {
    if (!this.wrapperRef.current) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 1) {
            this.canInterval = true;
            this.handleScrollIntel();
          } else {
            this.canInterval = false;
            cancelAnimationFrame(this.animationFrame);
          }
        });
      },
      {
        threshold: [0, 0.5, 1], 
      }
    );

    this.observer.observe(this.wrapperRef.current);
  };


  render() { 
    const customAttributes = {
      "data-component-id": this.props["data-component-id"],
      "data-component-name": this.props["data-component-name"],
    };

    // 基本配置信息
    const { baseConfig } = this.props.config;
    // 魔方列表
    const squareList = this.props.config.list;

    return (
      <div className="pipeline-square-wrapper"
        ref={this.wrapperRef}
        id={this.props['customAttributes']['data-component-id']}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0
        }}
      >
        {/* 触摸时暂停自动轮播 */}
        <div className="branchVenue" ref={this.scrollContainerRef}
          onTouchStart={(e) => {
            // const scrollContainer = e.currentTarget;
            // const listContainer = document.querySelector('.branchVenue-list');
            const scrollContainer = this.scrollContainerRef.current;
            const listContainer = this.listContainerRef.current;
            if (!scrollContainer || !listContainer || squareList.length <= 5) return;
            cancelAnimationFrame(this.animationFrame);  // 停止上一次自动滚动
            this.canInterval = false; // 停止自动滚动
            if (this.restartTimer) clearTimeout(this.restartTimer); // 清除之前延迟
            this.startX = e.touches[0].clientX; // 记录触摸起始位置
            this.scrollStartLeft = e.currentTarget.scrollLeft; // 记录滚动起始位置
          }}
          onTouchMove={(e) => {
            if (this.startX === null) return;

            const scrollContainer = this.scrollContainerRef.current;
            const listContainer = this.listContainerRef.current;
            if (!scrollContainer || !listContainer || squareList.length <= 5) return;

            const deltaX = e.touches[0].clientX - this.startX;
            let newScroll = this.scrollStartLeft - deltaX; // 左滑增加 scrollLeft
            const totalWidth = listContainer.scrollWidth / 2; // 原列表宽度

            // 无限循环滚动
            if (newScroll >= totalWidth) {
              newScroll -= totalWidth;
            } else if (newScroll <= 0) {
              newScroll += totalWidth;
            }
            e.currentTarget.scrollLeft = newScroll;
          }}
          onTouchEnd={(e) => {
            const scrollContainer = this.scrollContainerRef.current;
            const listContainer = this.listContainerRef.current;
            if (!scrollContainer || !listContainer || squareList.length <= 5) return;
            this.startX = null;
            this.canInterval = true; // 恢复自动滚动
            this.restartTimer = setTimeout(() => {
              this.handleScrollIntel(); // 1s后重新启动自动滚动
            }, 1000);
          }}
        >
          {/* 控制整体宽度依据内容自适应 */}
          <div className={`branchVenue-content ${squareList.some(item => item.showSubTitle) ? 'has-subtitile' : ''}`}
          >
              {/* 控制内部项目排列 */}
              <div className="branchVenue-list" ref={this.listContainerRef}>
                {
                  (squareList.length > 5 ? [...squareList, ...squareList] : squareList).map((item, index) => {
                    return (
                      <div
                        ref={ele => {
                          if (ele) {
                            this.props.exp && this.props.exp(ele);
                          }
                        }}
                        data-dot={JSON.stringify(utils.getExposureData(this.props, {
                          link: item.link,
                          sort: index,
                        }))}
                        key={`item_${index}`}
                        className={`branchVenue-item`}
                        onClick={this.handleItemClick.bind(this, item, index)}
                      >
                        <div className="img-area">
                          <div className="branchVenue-img">
                            <LazyLoadImage
                              width="100%"
                              threshold={500}
                              height="100%"
                              src={utils.formatImgUrl(item.img, this.props.webpSupport)}
                              effect="opacity"
                            />
                          </div>
                        </div>
                        <div className="main-title">{item.mainTitle}</div>
                        {item.showSubTitle && <div className="sub-title">{item.subTitle}</div>}
                      </div>
                    )
                  })
                }
              </div>
          </div>

        </div>

      </div>
    )
  }
}

PipelineSquare.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSquare };
export default PipelineSquare;


// WEBPACK FOOTER //
// ./components/pipeline-square/index.js